import React, { useState } from 'react'
import { Card } from 'react-bootstrap'
import callAPI from '../../../../helpers/callAPI'
import Loading from '../../../../templates/UI/Loading/Loading'
import ReportTable from '../../../../templates/ReportTable/ReportTable'

export default function RedirectAffiliateBlacklists({ showSystemMessage, data, dataLoaded, refetch }) {
    const [deleteIndex, setDeleteIndex] = useState(-1)

    const deleteBlacklist = async (type, notes, filter) => {
        const response = await callAPI(`compliance/blacklist`, 'DELETE', { type, notes, filter })
        if (response.success) {
            showSystemMessage('success', 'Redirect affiliate deleted successfully')
            setDeleteIndex(-1)
            refetch()
        } else {
            showSystemMessage('error', response.errors.message)
            setDeleteIndex(-1)
        }
    }

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'Affiliate ID',
                accessor: 'redirect_affiliate_id',
                Cell: ({ value }) => {
                    return <>{value}</>
                }
            },
            {
                Header: 'Notes',
                accessor: 'notes',
                Cell: ({ value }) => {
                    return <>{value}</>
                }
            },
            {
                Header: '',
                accessor: 'blacklists',
                Cell: (tableData) => {
                    let index = tableData.row.index

                    return (index === deleteIndex ?
                        <button className='btn btn-danger btn-sm' onClick={() => deleteBlacklist(tableData.data[tableData.row.index].type, tableData.data[tableData.row.index].notes, tableData.data[tableData.row.index].redirect_affiliate_id)}>Confirm Delete</button> 
                        :
                        <button className='btn btn-outline-danger btn-sm' onClick={() => setDeleteIndex(tableData.row.index)}>Delete</button>
                    )
                }
            }
        ]

        return (
            <React.Fragment>
                <ReportTable data={data.blacklist.filter(item => item.type === 'redirect')} columns={columns} />
            </React.Fragment>
        )
    }

    return (
        <Card className="mb-3">
            <Card.Header className="d-flex justify-content-between align-items-center">Redirect Affiliate Blacklist</Card.Header>
            {dataLoaded ? getReportOutput() : (
                <Loading />
            )}
        </Card>
    )
}
